"use client";
import { useState as n, useCallback as s } from "react";
function l() {
  const [r, e] = n(!1), o = s(async (t) => {
    if (!navigator?.clipboard)
      return console.warn("Clipboard not supported"), !1;
    try {
      return await navigator.clipboard.writeText(t), e(!0), setTimeout(() => {
        e(!1);
      }, 1e3), !0;
    } catch (a) {
      return console.warn("Copy failed", a), e(!1), !1;
    }
  }, []);
  return [r, o];
}
export {
  l as useCopyToClipboard
};
